import ECheckModalDesktop from './ECheckModalDesktop';

export default ECheckModalDesktop;
